<!-- Modal só aparece se isOpen for true -->
<div
  *ngIf="isOpen"
  class="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center p-4"
>
  <div class="bg-white max-w-3xl w-full rounded-lg shadow-lg p-6 relative">
    <h2 class="text-2xl font-bold text-green-800 mb-2">
      Sobre a última versão – <spam class="text-white bg-orange-500 rounded-lg pl-1 pr-1">{{ latestVersion.versao }}</spam>
    </h2>

    <p class="text-sm text-gray-600 italic mb-2">
      {{ latestVersion.titulo }} – {{ formatDate(latestVersion.data, 'completa') }}
    </p>

    <p class="text-sm text-gray-800 mb-4">{{ latestVersion.descricao }}</p>

    <hr class="my-4" />

    <div class="max-h-[50vh] overflow-y-auto pr-2">
      <h2 class="text-green-700 font-semibold mb-2">Atualizações de Versão</h2>

      <div *ngFor="let versao of changelogData" class="mb-6">
        <h3 class="text-green-700 font-semibold">
          <spam class="text-white bg-orange-500 rounded-lg pl-2 pr-2">{{ versao.versao }}</spam> - {{ versao.titulo }}
        </h3>
        <p class="text-xs text-gray-500">
          {{ formatDate(versao.data) }} —
          <code>{{ versao.branch }}</code>
        </p>
        <p class="text-sm text-gray-700 mb-2 italic">
          {{ versao.descricao }}
        </p>
        <ul class="list-disc list-inside text-sm text-gray-800">
          <li *ngFor="let m of versao.mudancas">
            <strong>{{ m.titulo }}:</strong> {{ m.detalhe }}
          </li>
        </ul>
      </div>
    </div>

    <div class="text-right mt-4">
      <button
        (click)="handleClose()"
        class="px-4 py-2 bg-orange-500 text-white rounded-full hover:bg-orange-600"
      >
        Fechar
      </button> 
    </div>
  </div>
</div>
